import { Outlet } from "react-router-dom";

/** Pass-through outlet for routes behind requireAuthenticatedLoader. */
export const AuthenticatedRouteOutlet = () => <Outlet />;
